import * as React from 'react';
import { useHistory } from 'react-router';
import { getAttributUrl } from 'app/shared/util/methode-util';
import { useSelector } from 'react-redux';
import { IRootState } from 'app/shared/reducers';
import { getDocument } from 'app/modules/cms/service/store/selectors';
import './foot.scss';

export interface ISpbFooter {
  visible: boolean;
  footerConstant: any;
  didomi?: any;
  productCode?: string;
  openDocument?: (url, type) => void;
  footerItems?: any;
}

export const SpbFooter: React.FC<ISpbFooter> = ({ visible, didomi, productCode, footerItems, footerConstant }): JSX.Element => {
  const footerData: any = useSelector<IRootState>(getDocument('generic_side_nav_v2'));
  const history = useHistory();

  const gestionCookies = didomiObject => {
    if (didomiObject) didomiObject.preferences.show();
  };

  const onFooterLinkClick = el => {
    history.push({
      pathname: '/document',
      state: { documentName: getAttributUrl(el.url, 'documentName'), default: getAttributUrl(el.url, 'default') },
    });
  };

  if (!visible) return null;
  
  else
    return (
      <>
        <div className="footer-container">
          <div className="footer-logo">
            <img className="footer-img" src={footerData?.data?.bottomicon?.url} />
          </div>
          <div className='footer-elements'>
            <div className="footer-items text-center">
            {footerItems?.map((el, index) => {
              if (footerConstant?.find(x => x.code.toString() === el.code.toString())) {
                return (
                  <React.Fragment key={'spb-footer' + index}>
                    <span className="p-2">•</span>
                    <a onClick={() => onFooterLinkClick(el)}>
                      {footerConstant && footerConstant?.find(x => x.code.toString() === el.code.toString())?.footer_text}
                    </a>
                  </React.Fragment>
                );
              }
            })}

            <a onClick={() => gestionCookies(didomi)} style={{ cursor: 'pointer' }} className={!didomi ? 'cookies-disabled' : ''}>
              <span className="p-2">• {"Politique d'utilisation des cookies"}</span>
            </a>
            </div>
            <div className="spb-footer-version"> Copyright © 2022 version : {process.env.REACT_APP_VERSION.replace('-SNAPSHOT', '')} </div>
          </div>
        </div>
      </>
    );
};
